(function () {
  'use strict';

  var loader = document.querySelector('[data-theme-preloader]');
  if (!loader || loader.dataset.initialized === 'true') return;
  loader.dataset.initialized = 'true';

  var veil = document.querySelector('[data-page-transition]');
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = loader.dataset.designMode === 'true';
  var duration = Number(loader.dataset.duration);
  duration = Number.isFinite(duration) ? Math.min(4000, Math.max(0, duration)) : 1400;
  var state = '';
  var finishTimer = 0;
  var hideTimer = 0;
  var navigationTimer = 0;
  var frame = 0;
  var cartRequests = new Set();

  function hide(immediate) {
    window.clearTimeout(finishTimer);
    window.clearTimeout(hideTimer);
    window.cancelAnimationFrame(frame);
    state = '';
    loader.classList.remove('is-active');
    loader.setAttribute('aria-hidden', 'true');
    if (veil) veil.classList.remove('is-active');
    if (immediate || motion.matches || loader.dataset.animation === 'none') {
      loader.hidden = true;
    } else {
      hideTimer = window.setTimeout(function () { loader.hidden = true; }, 220);
    }
  }

  function reset() {
    window.clearTimeout(navigationTimer);
    cartRequests.clear();
    hide(true);
  }

  function show(nextState, timeout) {
    hide(true);
    state = nextState;
    loader.hidden = false;
    loader.setAttribute('aria-hidden', 'false');
    frame = window.requestAnimationFrame(function () { loader.classList.add('is-active'); });
    finishTimer = window.setTimeout(function () { hide(false); }, timeout);
  }

  window.theme = window.theme || {};
  window.theme.preloader = {
    beginCart: function () {
      if (loader.dataset.cart !== 'true') return function () {};
      var request = {};
      cartRequests.add(request);
      if (state !== 'navigation') show('cart', 6000);
      return function () {
        cartRequests.delete(request);
        if (!cartRequests.size && state === 'cart') hide(false);
      };
    }
  };

  function showWelcome() {
    if (loader.dataset.initial !== 'true' || motion.matches || duration === 0) return;
    if (!designMode && loader.dataset.frequency !== 'page') {
      try {
        if (window.sessionStorage.getItem('renascens_preloader_seen')) return;
        window.sessionStorage.setItem('renascens_preloader_seen', 'true');
      } catch (error) {}
    }
    show('welcome', duration);
  }

  function eligibleURL(link) {
    if (!link || !link.href) return null;
    var base = document.querySelector('base[target]');
    var target = link.getAttribute('target') || (base && base.getAttribute('target'));
    if (target && target.toLowerCase() !== '_self') return null;
    if (link.hasAttribute('download') || link.relList.contains('external')) return null;
    if (link.closest('[data-no-loader], [data-no-transition], [data-panel-open], [data-panel-close], [data-quick-add], [data-quick-add-form], [data-product-form], [data-facet-remove], [data-load-more], [data-wishlist-toggle]')) return null;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (error) { return null; }
    if (!/^https?:$/.test(url.protocol) || url.origin !== window.location.origin) return null;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return null;
    if (/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname)) return null;
    if (url.searchParams.has('section_id') || url.searchParams.has('sections') || url.searchParams.get('view') === 'card') return null;
    return url;
  }

  window.addEventListener('click', function (event) {
    if (designMode || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!event.target || typeof event.target.closest !== 'function') return;
    var url = eligibleURL(event.target.closest('a[href]'));
    if (!url) return;
    var useLoader = loader.dataset.navigation === 'true';
    var useTransition = loader.dataset.transitions === 'true' && !motion.matches && !!veil;
    if (!useLoader && !useTransition) return;

    reset();
    if (useLoader) show('navigation', 6000);
    if (!useTransition) return;

    event.preventDefault();
    if (!useLoader) {
      veil.classList.add('is-active');
      finishTimer = window.setTimeout(reset, 6000);
    }
    navigationTimer = window.setTimeout(function () {
      try { window.location.assign(url.href); } catch (error) { reset(); }
    }, 180);
  });

  document.addEventListener('keydown', function (event) {
    if (state === 'welcome' || event.key === 'Escape') reset();
  });
  document.addEventListener('pointerdown', function () {
    if (state === 'welcome') reset();
  }, { passive: true });
  document.addEventListener('focusin', function () {
    if (state === 'welcome') reset();
  });
  window.addEventListener('pagehide', reset);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) reset();
  });
  if (motion.addEventListener) motion.addEventListener('change', reset);

  var logo = loader.querySelector('img');
  if (logo) {
    function showTextFallback() {
      logo.hidden = true;
      var fallback = loader.querySelector('[data-preloader-fallback]');
      if (fallback) fallback.hidden = false;
    }
    logo.addEventListener('error', showTextFallback);
    if (logo.complete && logo.naturalWidth === 0) showTextFallback();
  }

  showWelcome();
})();
